export function postNavigateToZadostMessage(zadostId) {
    postMessage('NAVIGATE_TO_ZADOST', {zadostId});
}

export function postNavigateToParkovaciKartaMessage(zadostId) {
    postMessage('NAVIGATE_TO_PARKOVACI_KARTA', {zadostId});
}

export function postDokoncidDokladPoukazMessage(poukazHlavickaId) {
    postMessage('DOKONCIT_DOKLAD_POUKAZ', {poukazHlavickaId});
}

function postMessage(type, params) {
    window.parent.postMessage({type, ...params}, '*');
}
